import React, {Component} from "react";
import {STR_NO_VALUE, STR_NO} from "./ProsConnect";
import BasicButton from "../components/BasicButton";
import {showMandatoryAndMissingMessage} from "./ProsCommonUi";

export default class ProsRbTagMenu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            initialIndex: this.props.selectedIndex,
            selectedIndex: this.props.selectedIndex
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedIndex !== this.props.selectedIndex) {
            this.setState({
                initialIndex: this.props.selectedIndex,
                selectedIndex: this.props.selectedIndex,
            })
        }
    }

    renderTag(tag, i) {
        const isSelected = i === this.state.selectedIndex
        return <BasicButton
            key={("tag_" + i)}
            icon={isSelected ? "check" : null}
            label={tag.label}
            action={() => {
                // first TAG is "state"
                let isStateTag = this.props.tagInd === 0
                // Multivalue can be deselected except if is a state
                let newVal = isSelected && !isStateTag ? STR_NO_VALUE : i
                this.setState({ selectedIndex: newVal })
                this.props.onSelect(newVal)
            }}
            selected={isSelected}
            className={tag.color !== STR_NO ? "bgcolor-hilite" : null}
            style={tag.color !== STR_NO ? {backgroundColor: '#' + tag.color} : null}
        />
    }

    getObsMultiSelectButtons(tagOptionIndeces) {
        if (!tagOptionIndeces) {
            return null
        }
        let mvTag = this.props.project.getMvTagSettings(this.props.tagInd)
        return tagOptionIndeces.map(i => {
            let option = mvTag.options.find(option => option.optionIndex === i)
            if (!option || !option.inUse) {
                return null
            }
            return this.renderTag(option, i)
        })
    }

    render() {
        const {tagOptionIndeces} = this.props
        if (!tagOptionIndeces) {
            return null
        }
        return <>
            {showMandatoryAndMissingMessage(this.state.selectedIndex < 0 && this.props.isMandatoryAndMissing)}
            <div className={"tag-collection"}>
                {this.getObsMultiSelectButtons(tagOptionIndeces)}
            </div>
        </>
    }
}
